import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type BalanceState = {
  showBalance: boolean
  toggleShowBalance: () => void
  setShowBalance: (show: boolean) => void
}

export const useBalanceStore = create<BalanceState>()(
  persist(
    (set) => ({
      showBalance: false,
      toggleShowBalance: () => set((state) => ({ showBalance: !state.showBalance })),
      setShowBalance: (show: boolean) => set({ showBalance: show }),
    }),
    {
      name: 'balance-storage', // unique name for localStorage key
    }
  )
)
